import axios from "axios";
import _ from "lodash";
import DOMPurify from 'dompurify'
const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL;

export function isFieldTemplateIdMatch(field1, field2) {
  return stripUnderscoresEtcFromFieldPattern(field1) === stripUnderscoresEtcFromFieldPattern(field2)
}

export function stripUnderscoresEtcFromFieldPattern(fieldPattern) {
  fieldPattern = fieldPattern.toString()
  fieldPattern =
    fieldPattern.lastIndexOf('__') === -1
      ? fieldPattern
      : fieldPattern.slice(0, fieldPattern.lastIndexOf('__'))

  fieldPattern = fieldPattern.lastIndexOf('_') === -1 ? fieldPattern : fieldPattern.slice(2)

  return fieldPattern
}

let processDataResultValue
let listDataValue
export const getDataByProcessTemplateId = async (process_template_id, axiosOptions) => {
  const processDataResult = (
    await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/process/${process_template_id}`,
      axiosOptions
    )
  ).data

  //TODO: can't hardcode 10 here
  const listData = (await axios.get(`${NODE_BASE_URL}/template/list-data/company`, axiosOptions))
    .data
  listDataValue = listData
  processDataResultValue = processDataResult
}

export const getValueForPlaceholder = async (fieldKey, listValue, processId) => {
  //f_13__1
  let fiteredProcessData = processDataResultValue?.filter((processData) => {
    return processData.id === processId
  })

  let placeholderObj = {}
  let pattern = /\[\[\d+\]\]/g
  let placeHoldersIds = listValue.match(pattern)
  placeHoldersIds?.forEach((ph) => {
    ph = ph.replace('[[', '').replace(']]', '')
    fiteredProcessData.forEach((processDatum) => {
      let data = processDatum.data
      let fKey = Object.keys(data).filter((key) => {
        return key === fieldKey
      })
      let rowNum = fKey.toString()?.split('__')[1]
      if (rowNum !== undefined) {
        let finalKey = 'f_' + ph + '__' + rowNum
        listDataValue.forEach((listDatum) => {
          if (listDatum.id == data[finalKey]) {
            placeholderObj[`[[${ph}]]`] = `${listDatum.value}`
          }
        })
      }
    })
  })
  let alteredListData = listValue.replace(pattern, (m) => placeholderObj[m])
  return alteredListData
}

export function getCurrentFinancialYear() {
  const today = new Date()
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth() + 1

  // Check if the current month is after March (start of financial year)
  if (currentMonth >= 4) {
    return currentYear + '-' + (currentYear + 1).toString().slice(-2)
  } else {
    return currentYear - 1 + '-' + currentYear.toString().slice(-2)
  }
}

export function intersection() {
  var result = []
  var lists

  if (arguments.length === 1) {
    lists = arguments[0]
  } else {
    lists = arguments
  }

  for (var i = 0; i < lists.length; i++) {
    var currentList = lists[i]
    for (var y = 0; y < currentList.length; y++) {
      var currentValue = currentList[y]
      if (result.indexOf(currentValue) === -1) {
        if (
          lists.filter(function (obj) {
            return obj.indexOf(currentValue) == -1
          }).length == 0
        ) {
          result.push(currentValue)
        }
      }
    }
  }
  return result
}

export function combineArrays(array_of_arrays) {
  // First, handle some degenerate cases...
  if (!array_of_arrays) {
    // Or maybe we should toss an exception...?
    return []
  }

  if (!Array.isArray(array_of_arrays)) {
    // Or maybe we should toss an exception...?
    return []
  }

  if (array_of_arrays.length == 0) {
    return []
  }

  for (let i = 0; i < array_of_arrays.length; i++) {
    if (!Array.isArray(array_of_arrays[i]) || array_of_arrays[i].length == 0) {
      // If any of the arrays in array_of_arrays are not arrays or zero-length, return an empty array...
      return []
    }
  }

  // Done with degenerate cases...

  // Start "odometer" with a 0 for each array in array_of_arrays.
  let odometer = new Array(array_of_arrays.length)
  odometer.fill(0)

  let output = []

  let newCombination = formCombination(odometer, array_of_arrays)

  output.push(newCombination)

  while (odometer_increment(odometer, array_of_arrays)) {
    newCombination = formCombination(odometer, array_of_arrays)
    output.push(newCombination)
  }

  return output
}

// Translate "odometer" to combinations from array_of_arrays
function formCombination(odometer, array_of_arrays) {
  // In Functional Programmingese (Henny Youngman one-liner):
  return odometer.reduce(function (accumulator, odometer_value, odometer_index) {
    return '' + accumulator + '|' + array_of_arrays[odometer_index][odometer_value]
  }, '')
}

function odometer_increment(odometer, array_of_arrays) {
  // Basically, work you way from the rightmost digit of the "odometer"...
  // if you're able to increment without cycling that digit back to zero,
  // you're all done, otherwise, cycle that digit to zero and go one digit to the
  // left, and begin again until you're able to increment a digit
  // without cycling it...simple, huh...?

  for (let i_odometer_digit = odometer.length - 1; i_odometer_digit >= 0; i_odometer_digit--) {
    let maxee = array_of_arrays[i_odometer_digit].length - 1

    if (odometer[i_odometer_digit] + 1 <= maxee) {
      // increment, and you're done...
      odometer[i_odometer_digit]++
      return true
    } else {
      if (i_odometer_digit - 1 < 0) {
        // No more digits left to increment, end of the line...
        return false
      } else {
        // Can't increment this digit, cycle it to zero and continue
        // the loop to go over to the next digit...
        odometer[i_odometer_digit] = 0
        continue
      }
    }
  }
}

export function fieldAndValueAreEqual(prevProps, nextProps) {
  return (
    prevProps.fieldAndValue?.name === nextProps.fieldAndValue?.name &&
    prevProps.fieldAndValue?.value === nextProps.fieldAndValue?.value &&
    prevProps.disabled === nextProps.disabled &&
    prevProps?.isEqualField === nextProps?.isEqualField &&
    JSON.stringify(prevProps.field) === JSON.stringify(nextProps.field)
  )
}

export const fieldAndValueAreEqualDependencyMap = (prevProps, nextProps) => {
  return (
    fieldAndValueAreEqual(prevProps, nextProps) &&
    _.isEqual(prevProps.listDataDependencyMap, nextProps.listDataDependencyMap)
  )
}

export const getPDFPreviewData = async (fileKey, user) => {
  const result = (
    await axios.get(`${NODE_BASE_URL}/data-entry/file/base64-images/${fileKey}`, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    })
  ).data
  return result
};


export const santizeHtml = (dirtyHtml) => {
  const sanitizedHtml = DOMPurify.sanitize(dirtyHtml, {
    WHOLE_DOCUMENT: true, // To retain <!DOCTYPE html> and <html>
    FORBID_TAGS: ['script'], // Disallow script tags
    FORBID_ATTR: ['on*'], // Disallow attributes like onclick, onmouseover, etc.
    ALLOW_UNKNOWN_PROTOCOLS: true, // To allow custom protocols like mailto, tel, etc.
  })
  return sanitizedHtml
}
